import React from "react";
import styled from "@emotion/styled";
import withTranslator from "../Translator/withTranslation";

const CloseButtonContainer = styled.button`
    background-color: #fff;
    color: #484848;
    font-weight: normal;
    font-size: 60%;
    padding: 10px 17px 10px 10px;
    @media (max-width:600px){
        font-size: 80%;
    }
`;

class CloseButtonComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    
    onClick = () => {
        this.props.onClick();
    }
    
    render() {
        const { t } = this.props;
        return (
            <CloseButtonContainer
                onClick={this.onClick}
                className="font-80 btn-no pointer bor-no"
            >
            {t('close')}
            </CloseButtonContainer>
        );
    }
}

export const CloseButton = withTranslator(CloseButtonComponent);